module.exports = __webpack_public_path__ + "street.png?b79c54be8d39f80bb4f99b840eedf86c";